import React, { useState, useEffect } from 'react';
import API from '../../api';
import { toast } from 'react-toastify';

const SalaryAdvance = () => {
  const [employeeList, setEmployeeList] = useState([]);
  const [formData, setFormData] = useState({
    employee_id: '',
    amount: '',
    date: '',
    reason: '',
  });
  const [advances, setAdvances] = useState([]);
  const [filterMonth, setFilterMonth] = useState('');

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const res = await API.get('/employees');
        setEmployeeList(res.data.employees);
      } catch (err) {
        console.error('Error fetching employees:', err);
      }
    };
    fetchEmployees();
  }, []);

  const fetchAdvances = async () => {
    try {
      const res = await API.get('/salary-advances');
      setAdvances(res.data || []);
    } catch (err) {
      console.error('Error fetching advances:', err);
    }
  };

  useEffect(() => {
    fetchAdvances();
  }, []);

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await API.post('/salary-advances/add', formData);
      toast.success('Advance salary submitted!');
      setFormData({ employee_id: '', amount: '', date: '', reason: '' });
      fetchAdvances();
    } catch (err) {
      toast.error('Failed to submit advance salary');
    }
  };

  const filteredAdvances = filterMonth
    ? advances.filter(a => a.date.startsWith(filterMonth))
    : advances;

  return (
    <div className="max-w-6xl mx-auto px-4 py-8">
      <div className="bg-white shadow-md rounded-2xl p-6">
        <h2 className="text-2xl font-bold mb-6 text-blue-700">💰 Advance Salary Form</h2>

        <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">Employee</label>
            <select
              name="employee_id"
              value={formData.employee_id}
              onChange={handleChange}
              required
              className="w-full border border-gray-300 focus:outline-none focus:border-gray-400 rounded px-3 py-2"
            >
              <option value="">-- Select Employee --</option>
              {employeeList.map(emp => (
                <option key={emp.id} value={emp.id}>
                  {emp.full_name} ({emp.employee_id})
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Amount (₹)</label>
            <input
              type="number"
              name="amount"
              value={formData.amount}
              onChange={handleChange}
              required
              className="w-full border border-gray-300 focus:outline-none focus:border-gray-400 rounded px-3 py-2"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Date</label>
            <input
              type="date"
              name="date"
              value={formData.date}
              onChange={handleChange}
              required
              className="w-full border border-gray-300 focus:outline-none focus:border-gray-400 rounded px-3 py-2"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Reason</label>
            <input
              type="text"
              name="reason"
              value={formData.reason}
              onChange={handleChange}
              className="w-full border border-gray-300 focus:outline-none focus:border-gray-400 rounded px-3 py-2"
            />
          </div>

          <div className="md:col-span-4 text-right mt-4">
            <button
              type="submit"
              className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-xl font-medium transition duration-150"
            >
              Submit
            </button>
          </div>
        </form>
      </div>

      <div className="mt-10">
        <label className="block text-sm font-medium text-gray-700 mb-2">📅 Filter by Month</label>
        <input
          type="month"
          value={filterMonth}
          onChange={(e) => setFilterMonth(e.target.value)}
          className="border border-gray-300 rounded-lg px-3 py-2 w-64"
        />
      </div>

      <div className="mt-6 overflow-x-auto bg-white shadow rounded-2xl">
        <h3 className="text-xl font-semibold px-4 py-3 bg-blue-50 border-b">📄 Advance Salary History</h3>

        {filteredAdvances.length === 0 ? (
          <p className="text-gray-500 px-4 py-6">No records found for the selected month.</p>
        ) : (
          <table className="min-w-full text-sm text-left">
            <thead className="bg-gray-100 sticky top-0 z-10">
              <tr>
                <th className="px-4 py-2 border">#</th>
                <th className="px-4 py-2 border">Employee</th>
                <th className="px-4 py-2 border">Amount</th>
                <th className="px-4 py-2 border">Date</th>
                <th className="px-4 py-2 border">Reason</th>
              </tr>
            </thead>
            <tbody>
              {filteredAdvances.map((adv, index) => (
                <tr key={adv.id} className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}>
                  <td className="px-4 py-2 border">{index + 1}</td>
                  <td className="px-4 py-2 border">{adv.full_name} ({adv.employee_id})</td>
                  <td className="px-4 py-2 border">₹{adv.amount}</td>
                  <td className="px-4 py-2 border">{adv.date}</td>
                  <td className="px-4 py-2 border">{adv.reason || '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default SalaryAdvance;
